module.exports = __webpack_public_path__ + "images/category_lp/common/icon-voice-man-30@2x_7846ff9e8cdd1a03c88a45c68d94bac5.png";